import '../input/radio-input';

import{ html, TemplateResult } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import { CartData, cartStore } from '../../_stores/cart-store';
import { CheckoutForm } from './checkout-form';
import { RadioInput } from '../input/radio-input';

@customElement('shipping-form')
export class ShippingForm extends CheckoutForm {

    @state()
    _shippingHandle?: string = null;

    // Lifecycle Hooks

    async firstUpdated() {

        // add classes
        this.classList.add('Form', 'Form--shipping');

		// handle slots
        const slot: HTMLElement | null = this.querySelector('[slot="crsf"]');
        if (slot) {
            this._crsf = slot.innerHTML;
            slot.remove();
        }

        // shipping data
        let cartData = cartStore.data.get();
        if (!cartData) cartData = await cartStore.getCart();
        this._shippingHandle = cartData?.shippingMethodHandle;
    }

    // Render

    render() {
        const cartData = cartStore.data.get();
        return html`
            <form 
                autocomplete="on" 
                method="post"
                @change="${ this._validate }">
                ${ unsafeHTML(this._crsf) }
                <section class="Form-body">
                    <div class="Form-grid">
                        ${ this.shippingInputTemplate(cartData) }
                    </div>
                </section>
            </form>
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Templates
    
    // NOTE: pickup addresses are mirrored in templates/_email/order-pickup.twig. Keep both in sync.
    private readonly _pickupAddresses: Record<string, string> = {
        pickupNewYork: 'Swiss Institute Office\n117 2nd Ave, Apt 2\nNew York, New York 10003',
        pickupZurich: 'Luma Westbau\nLöwenbräukunst, Limmatstrasse 270\n8005 Zürich, Switzerland',
    };

    shippingInputTemplate(cartData: CartData): TemplateResult {
        const error = this._errors['shippingMethodHandle'];
        const options = (cartData?.availableShippingMethodOptions)
            ? Object.values(cartData.availableShippingMethodOptions)
                .map((option) => {
                    return {
                        value: option.handle,
                        label: `${ option.name }: ${ option.priceAsCurrency }`,
                        description: this._pickupAddresses[option.handle],
                    }
                })
            : [];
        return html`
            <div class="Form-block" col-span="2">
                ${ (options.length) 
                    ? html`<radio-input
                            name="shippingMethodHandle"
                            value="${ cartData?.shippingMethodHandle ?? '' }"
                            required="true"
                            .options="${ options }"
                            @change=${ this._updateShippingHandle }>
                        </radio-input>`
                    : this.messageTemplate('No shipping methods available')
                }
                ${ (error) ? this.alertTemplate(error) : '' }
            </div>
        `;
    }

    // Methods
    _updateShippingHandle(e: Event) {
        const input = e.target as RadioInput;
        this._shippingHandle = input.value;
        this.requestUpdate();
    }

}